import { Tabs, Empty } from 'antd';
import RxspIcon from '@/icons/home/rxsp.svg'
import TjclIcon from '@/icons/home/tjcl.svg'
import ZsclIcon from '@/icons/home/zscl.svg'
import AzclIcon from '@/icons/home/azcl.svg'
import ArrowIcon from '@/icons/arrow.svg';
import { useState } from 'react'
import { cls } from 'reactutils'
import ProductCard from './ProductCard'
import HomeFloorBg from '@/images/cscec3b/home/home-floor.png'
const { TabPane } = Tabs;
const iconList = [<RxspIcon key="RxspIcon" />, <TjclIcon key="TjclIcon" />, <ZsclIcon key="ZsclIcon" />, <AzclIcon key="AzclIcon" />]
export default function HomeFloor({ hotData, floorsData }) {
  const list = [...(hotData || []), ...(floorsData || [])].slice(0, 4)
  const [currentFloor, setCurrentFloor] = useState(list[0])
  const [activeKey, setActiveKey] = useState('0')
  const onTabClick = (key) => {
    setActiveKey(key)
  }
  const activeCategory = currentFloor?.children?.[activeKey]
  return <div className="floor-container">
    <div className="floor-warpper">
      <div className="floor-modules">
        {
          list.map((floor, index) => <div className={cls("floor-item", floor.id === currentFloor.id && 'active')} key={floor.id} onClick={() => {
            setCurrentFloor(floor)
            setActiveKey('0')
          }}>
            <span className='icon-box'>
              {iconList[index]}
            </span>
            <div style={{marginLeft: '14px'}}>
              <div className='title' title={floor.title}>{floor.title}</div>
              <div className='desc' title={floor.description}>{floor.description}</div>
            </div>
          </div>)
        }
      </div>
      {!!currentFloor && <div className='floor-content'>
        <Tabs
          activeKey={activeKey}
          onTabClick={onTabClick}
          tabPosition="top"
          tabBarExtraContent={{ right: <span className='right' onClick={() => {
            window.open(activeCategory.link || `/product/list?catId=${activeCategory.bizSysNo}`)
          }}>
            查看更多
            <span className="arrow-icon">
              <ArrowIcon style={{ width: '12px', height: '14px'}} />
            </span>
          </span> }}
          animated
        >
          {currentFloor.children.map((item, index) => (
              <TabPane tab={item.title} key={index}>
                  <div className="content">
                    {!!item?.skuList?.length ? (
                      item.skuList.slice(0, 10).map((v, index) => (
                        <ProductCard item={v} key={index} />
                      ))
                    ) : (
                      <div className="no-data">
                        <Empty />
                      </div>
                    )}
                  </div>
              </TabPane>
            ))}
        </Tabs>
      </div>}
    </div>
    <style jsx>{`
      .floor-container {
        padding: 50px 0 80px;
        background-color: #fff;
        background-image: url(${HomeFloorBg});
        background-size: cover;
      }
      .floor-warpper {
        width: 1200px;
        margin: 0 auto;
      }
      .floor-modules {
        display: flex;
        justify-content: space-between;
      }
      .floor-item {
        width: 288px;
        padding: 0 20px 23px;
        border-bottom: 2px solid #E9EFF4;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .floor-item.active {
        border-color: #018DD7;
      }
      .title {
        font-size: 20px;
        line-height: 28px;
        color: #212529;
        font-weight: 600;
      }
      .desc {
        color: #737687;
        line-height: 20px;
      }
      .floor-content {
        padding: 24px;
        border-radius: 12px;
        background: #FFF;
        margin-top: 32px;
        box-shadow: 0px 4px 60px 0px rgba(0, 28, 85, 0.08);
      }
      .no-data {
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #999;
      }
      .right {
        color: #737687;
        vertical-align: middle;
        cursor: pointer;
        display: flex;
        align-items: center;
        line-height: 14px;
      }
        
      .arrow-icon {
        margin-left: 4px;
      }
      // .floor-content :global(.ant-tabs-nav) {
      //   height: 38px;
      // }
    `}</style>
  </div>
}